import React from 'react'

export default function AllIncentives() {
  return (
    <div>
      
    </div>
  )
}
